import initCartImport from './initCart'

export const initCart = initCartImport



// WEBPACK FOOTER //
// ./src/store/modules/cart/actions/index.js